function LogUserFilter ({ value, users, loading, onChange, className = 'col-12 col-md-3' }) {
  return (
    <div className={className}>
      <label className="form-label small text-muted mb-1">User</label>
      <select className="form-select" value={value} onChange={onChange} disabled={loading}>
        <option value="ALL">ALL</option>
        {users.map((user) => (
          <option key={user.id} value={user.id}>
            {user.name || user.email || `User #${user.id}`}{user.email && user.name ? ` (${user.email})` : ''}
          </option>
        ))}
      </select>
    </div>
  )
}

export default LogUserFilter
